import * as React from 'react';
import Accordion, { AccordionSlots } from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { withTranslation } from "react-i18next";
import Fade from '@mui/material/Fade';
import { Stack } from '@mui/material';

const StartHarpPageAccordion = ({ t, i18 }) => {
    const [expanded, setExpanded] = React.useState(null);

    const handleExpansion = (id) => {
        setExpanded(expanded === id ? null : id);
    };
    const steps = t("begin_page.steps", { returnObjects: true });
    return (
        <div>
            {Array.isArray(steps) && steps.map((step, index) => (
                <div>
                    <Typography variant='h5'>{t(step.question)}</Typography>
                    <Accordion
                        expanded={expanded === index}
                        onChange={() => handleExpansion(index)}
                        // slots={{ transition: Fade as AccordionSlots['transition'] }}
                        slotProps={{ transition: { timeout: 400 } }}
                        sx={{
                            '& .MuiAccordion-region': { height: expanded === index ? 'auto' : 0 },
                            '& .MuiAccordionDetails-root': { display: expanded === index ? 'block' : 'none' },
                            '& .MuiAccordion-root': { background: 'none', border: '0px' },
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        }}
                        key={index}
                    >
                        <AccordionSummary
                            aria-controls="panel1-content"
                            id="panel1-header"
                            style={{ padding: '0px' }}
                        >
                            <Stack direction={'row'}  >
										{expanded === index ? (
											<>
												<ExpandLessIcon color="primary" />
												<Typography color="primary">
												{t("begin_page.hide_details")} {Number(index) + 1}
												</Typography>
											</>
										) : (
											<>
												<ExpandMoreIcon color="primary" />
												<Typography color="primary">
												{t("begin_page.show_details")} {Number(index) + 1}
												</Typography>
											</>
										)}
                            </Stack>
                        </AccordionSummary>
                        <AccordionDetails>
                            <div style={{ whiteSpace: 'pre-line' }}>{t(step.answer).replace('#COLON', ':')} </div>
                        </AccordionDetails>
                    </Accordion>
                </div>
            ))}

        </div>
    );
}
export default withTranslation("common")(StartHarpPageAccordion)